
import { Component, Vue } from 'vue-property-decorator'
import {
    confirmRecieve,
    OrderParamsDTO,
    purchaseGoodsAgain,
    LoanOrderInfoDto,
    getLoanOrderInfoList
} from '@/api/shopOrder'
import { Getter } from 'vuex-class'
import { submitLoanOrder, toQuotaResDto } from '@/api/customerManage'
import { openNewPage } from '@/utils/h5ToApp'
import { getInterestFree, getRegulations } from '@/api/guarantee'
import { number } from 'echarts'

@Component({
    name: 'OrderSelect'
    // components: {OrderFilter}
})
export default class OrderSelect extends Vue {
    @Getter companyId!: string
    checked = false
    money = null
    interestFree = 0
    refreshing = false
    loading = false
    finished = false
    params: OrderParamsDTO = {
        companyId: '',
        merchantId: '', // 客户编号
        pageIndex: 1,
        pageSize: 20
    }
    orderList: LoanOrderInfoDto[] = []

    created () {
        this.params.companyId = this.companyId
        this.params.merchantId = this.$route.query.id as string
        this.getOrderList()
        this.getInterestFree()
    }

    getOrderList () {
        getLoanOrderInfoList(this.params)
            .then((res) => {
                this.orderList = res.data.records || []
                if (this.orderList && this.orderList.length > 0) {
                    this.orderList.forEach((item) => {
                        item.isChecked = false
                    })
                    this.orderList = JSON.parse(JSON.stringify(this.orderList))
                }

                if (this.orderList.length >= res.data.totalRecords) {
                    this.finished = true
                } else {
                    this.finished = false
                }
            })
            .finally(() => {
                this.refreshing = false
            })
    }

    getFilterParams (data: OrderParamsDTO) {
        this.params = Object.assign(this.params, data)
        this.getOrderList()
    }

    getInterestFree () {
        getInterestFree({companyId: this.params.merchantId}).then(res => {
          this.interestFree = res.data.interestFree
        })
    }

    /**
     * 下拉刷新
     * */
    onRefresh () {
        this.params.pageIndex = 1
        this.refreshing = true
        this.getOrderList()
    }

    /**
     * 上拉加载更多
     */
    onLoad () {
        this.params.pageIndex++
        this.loading = true
        getLoanOrderInfoList(this.params)
            .then((res) => {
                this.orderList = this.orderList.concat(res.data.records)
                this.loading = false
                if (this.orderList.length >= res.data.totalRecords) {
                    this.finished = true
                }
            })
            .catch(() => {})
    }

    orderFilter () {
        (this.$refs.orderFilter as any).show()
    }

    toDetail (id: string, routeId: number) {
        this.$router.push({
            path: '/shopOrderDetail',
            query: {
                orderId: id,
                currRouteId: String(routeId)
            }
        })
    }

    // 查看日志
    // 分为退单和订单，订单isReturn 0 退单：isReturn 1
    toLog (orderInfo) {
        if (!this.$isAction(`toLog`)) {
            this.$toast('暂无此操作权限，请联系管理员')
            return false
        }
        this.$router.push({
            path: '/log',
            query: {
                currRouteId: orderInfo.currRouteId,
                orderId: orderInfo.orderId,
                isReturn: '0'
            }
        })
    }

    /**
     * 再次购买
     * @param data 订单数据
     */
    buyAgain (data: LoanOrderInfoDto) {
        const obj = {
            orderId: data.orderId,
            customerId: this.companyId,
            shopId: data.shopCompanyId,
            currRouteId: data.currRouteId
        }
        purchaseGoodsAgain(obj)
            .then(() => {
                this.$toast.success('已添加至购物车')
            })
            .catch(() => {})
    }

    /**
     * 确认收货
     * @param data 订单数据
     */
    confirmOrder (data: LoanOrderInfoDto) {
        const obj = {
            orderId: data.orderId,
            companyId: this.companyId,
            shopId: data.shopCompanyId,
            currRouteId: data.currRouteId
        }
        confirmRecieve(obj)
            .then((res) => {
                let msg = ''
                if (res.code === '000000') {
                    msg = '确认收货成功'
                } else if (res.code === '000002') {
                    msg = '订货单状态已变更'
                }
                this.$dialog
                    .alert({
                        message: msg
                    })
                    .then(() => {
                        this.getOrderList()
                    })
            })
            .catch(() => {})
    }

    /**
     * 跳转到订单选择页面
     */
    toOrderSelect () {
        this.$router.push({
            path: ''
        })
    }

    /**
     * 格式化金额 仅可录入数字
     * @param value
     */
    formatterMoney (value) {
        return value
            .replace(/[^0-9.]/g, '')
            .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
            .replace(/0*(\d+)/, '$1')
    }

    /**
     * 去借款
     */
    toLoan () {
        const list = this.orderList
            .filter((item) => item.isChecked)
            .map((item) => {
                return {
                    currRouteId: item.currRouteId,
                    orderId: item.orderId,
                    orderTradeMoney: item.orderTradeMoney,
                    companyId: item.shopCompanyId
                }
            })
        if (!list || list.length <= 0) {
            return this.$toast('请选择本次借款对应订单')
        }

        const emptyData =
            list.filter((item) => {
                return !item.orderTradeMoney
            }) || []
        if (emptyData.length > 0) {
            return this.$toast('请录入订单借款金额')
        }

        const obj = {
            companyId: this.params.companyId,
            merchantId: this.params.merchantId,
            orderList: list
        }
        submitLoanOrder(obj).then((res) => {
            if (res.code === '000000') {
              console.log('this.interestFree', this.interestFree)
              if(Number(this.interestFree) === 1) {
                this.toDescription(res.data)
              } else {
                this.toFreeLogin(res.data)
              }

            }
        })
    }

    /**
     * 跳转到免登录页面
     * @param data 后端接口返回数据
     */
    toFreeLogin (data: toQuotaResDto) {
        openNewPage({url: data.redirectUrl})
    }

    /**
     * 跳转到免息权益说明
     * @param data 后端接口返回数据
     */
    toDescription (data: toQuotaResDto) {
      console.log('data.redirectUrl', data.redirectUrl)
      this.$router.push({
        path: '/description',
        query: {
          url: data.redirectUrl,
          merchantId: this.params.merchantId
        }
      })
    }
}
